export default "<router-outlet></router-outlet>\r\n<app-navbar></app-navbar>\r\n<app-sidebar></app-sidebar>\r\n";